export default __webpack_public_path__ + "static/solopic-54501a09563b341afb03846cc827275c.jpg";